/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  HanaiMock,
  HanaiMockInterface,
} from "../../../contracts/mock/HanaiMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "authority",
        type: "address",
      },
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
      {
        internalType: "address",
        name: "royaltyAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ApprovalToOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "ArrayLengthMismatch",
    type: "error",
  },
  {
    inputs: [],
    name: "BurningInactive",
    type: "error",
  },
  {
    inputs: [],
    name: "DuplicatedMint",
    type: "error",
  },
  {
    inputs: [],
    name: "ExceedMaxTicket",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPayment",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSaleOn",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSignature",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidTime",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidTokenId",
    type: "error",
  },
  {
    inputs: [],
    name: "MetadataFrozen",
    type: "error",
  },
  {
    inputs: [],
    name: "NonAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "NonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "NonExistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "NonLocker",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrOperator",
    type: "error",
  },
  {
    inputs: [],
    name: "RoyaltyPercentageExceed",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferDeactive",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLocked",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLockedByLocker",
    type: "error",
  },
  {
    inputs: [],
    name: "WithdrawFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "LockTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "refundFailed",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "burningActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tierIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tierStartTimes",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tierDurations",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tierMaxTicketNums",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tierTicketPrices",
        type: "uint256[]",
      },
    ],
    name: "configSales",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "lockTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "bool[]",
        name: "locks",
        type: "bool[]",
      },
    ],
    name: "lockTransfers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lockers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "metadataFrozen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tos",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
    ],
    name: "privateMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "provenance",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tierId",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "publicMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "publicMints",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "saleOn",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "authority",
        type: "address",
      },
    ],
    name: "setAuthority",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "provenance_",
        type: "bytes32",
      },
    ],
    name: "setProvenance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "royaltyReceiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyPercentage",
        type: "uint256",
      },
    ],
    name: "setRoyaltyInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tiers",
    outputs: [
      {
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxTicketNum",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ticketPrice",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "flag",
        type: "uint256",
      },
    ],
    name: "toggleFlag",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "transferDeactive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transferLocks",
    outputs: [
      {
        internalType: "enum HanaiBase.LockStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "updateAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "locker",
        type: "address",
      },
      {
        internalType: "bool",
        name: "valid",
        type: "bool",
      },
    ],
    name: "updateLocker",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type HanaiMockConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: HanaiMockConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class HanaiMock__factory extends ContractFactory {
  constructor(...args: HanaiMockConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    authority: PromiseOrValue<string>,
    admin: PromiseOrValue<string>,
    royaltyAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<HanaiMock> {
    return super.deploy(
      authority,
      admin,
      royaltyAddress,
      overrides || {}
    ) as Promise<HanaiMock>;
  }
  override getDeployTransaction(
    authority: PromiseOrValue<string>,
    admin: PromiseOrValue<string>,
    royaltyAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      authority,
      admin,
      royaltyAddress,
      overrides || {}
    );
  }
  override attach(address: string): HanaiMock {
    return super.attach(address) as HanaiMock;
  }
  override connect(signer: Signer): HanaiMock__factory {
    return super.connect(signer) as HanaiMock__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): HanaiMockInterface {
    return new utils.Interface(_abi) as HanaiMockInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): HanaiMock {
    return new Contract(address, _abi, signerOrProvider) as HanaiMock;
  }
}
